export default class HubType {
    private _id: string | undefined;
    private _name: string;
    private _status: boolean = false;

    constructor(id: string | undefined, name: string, status: boolean){
        this._id = id;
        this._name = name;
        this._status = status;   
    }

    public get id(): string | undefined {
        return this._id;
    }
    public set id(value: string | undefined) {
        this._id = value;
    }
    public get name(): string {
        return this._name;
    }
    public set name(value: string) {
        this._name = value;
    }
    public get status(): boolean {
        return this._status;
    }
    public set status(value: boolean) {
        this._status = value;
    }
    
}
